import { render, staticRenderFns } from "./VeEmailDesignSettings.vue?vue&type=template&id=549fe5ea"
import script from "./VeEmailDesignSettings.vue?vue&type=script&lang=js"
export * from "./VeEmailDesignSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports